import React, { useState, useEffect, useRef } from 'react';
import './PhoneVerify.css';

import { PageTitle } from '../../../components';

import { FaUserAlt, FaMobile, FaLock, FaPenFancy, FaPhone, FaRegCreditCard, FaQrcode } from 'react-icons/fa';
import { CountdownButton } from '../../../components';

import Cookies from 'js-cookie';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { MessageModal } from '../../../components';
import { useTokenCheck, getUserProfile, callSendMobileAuth, callMobileAuth } from '../../../constants';
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';

const PhoneVerify = () => {
  const { nickName, isCanExecute } = useTokenCheck();

  const navigate = useNavigate();
  const location = useLocation();
  let isGoToMemberProfile = location?.state?.nextPage === '/MemberProfile';
  const [countdownTime, setCountdownTime] = useState(-1);
  const [mobileNo, setMobileNo] = useState('');
  const [VerifyCode, setVerifyCode] = useState('');
  const inputVerifyCodeRef = useRef(null);

  const handleVerifyCode = (e) => {
    const value = e.target.value;
    setVerifyCode(value);
  };

  useEffect(() => {
    if (!isCanExecute) return;
    getUserProfile().then(payload => {
      const isPayloadValid =
        payload?.status !== undefined &&
        payload?.errorCode !== undefined &&
        payload?.data !== undefined &&
        payload?.errorMessage !== undefined;

      if (isPayloadValid) {
        if (payload.status === 0 && payload.errorCode === '0000') {
          //處理結果

          const MobileNo = payload.data.mobileNo;
          const phoneAuth = payload.data.phoneAuth;

          setMobileNo(MobileNo);

          if (phoneAuth.isAuth) {
            //回首頁
            navigate('/');
            return;
          }

          if (Cookies.get('cookieConsent') === 'accepted') {
            const offsetSecond = Cookies.get('offsetSecond');

            if (offsetSecond) {
              if (!isNaN(Number(offsetSecond))) {
                setCountdownTime(Number(offsetSecond));
              }
            } else {
              callApiSendMobileAuth();
            }
          } else {
            //沒用Cookie的路線暫時不處理
          }
        } else if (payload.status === 1 &&
          (payload.errorCode === '9997' || payload.errorCode === '9998')) {
          //未登入
          let errorMessage = "Token過期，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else if (payload.status === 1 && payload.errorCode === '9996') {
          //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
          let errorMessage = "查無此會員，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else {
          let errorMessage = payload.errorMessage;
          MessageModal.alert(errorMessage);
        }
      }
    }).catch(error => {
      console.error('Error during API call:', error);
    });

  }, [isCanExecute]);


  const callApiSendMobileAuth = async () => {
    //發送簡訊
    callSendMobileAuth().then(payload => {
      const isPayloadValid =
        payload?.status !== undefined &&
        payload?.errorCode !== undefined &&
        payload?.data !== undefined &&
        payload?.errorMessage !== undefined;

      if (isPayloadValid) {
        if (payload.status === 0 && payload.errorCode === '0000') {
          //處理結果
          let waitSecond = payload.data.waitSecond;

          setCountdownTime(waitSecond);
          if (Cookies.get('cookieConsent') === 'accepted') {
            Cookies.set('offsetSecond', waitSecond, { expires: waitSecond / 86400 });
          } else {
            //沒用Cookie的路線暫時不處理
          }
        } else if (payload.status === 1 && payload.errorCode === '0771') {
          const offsetSecond = payload.data.offsetSecond;

          if (offsetSecond && !isNaN(Number(offsetSecond))) {
            //以防萬一Cookie沒了，重新設置
            setCountdownTime(Number(offsetSecond));
          }
        } else if (payload.status === 1 &&
          (payload.errorCode === '9997' || payload.errorCode === '9998')) {
          //未登入
          let errorMessage = "Token過期，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else if (payload.status === 1 && payload.errorCode === '9996') {
          //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
          let errorMessage = "查無此會員，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else {
          let errorMessage = payload.errorMessage;
          MessageModal.alert(errorMessage);
        }
      }
    }).catch(error => {
      console.error('Error during API call:', error);
    });

  };

  const validateLength = (value) => {
    return value.trim().length === 0;
  };
  const handleCountdownButton = () => {
    callApiSendMobileAuth();
  }

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior

    if (validateLength(VerifyCode)) {
      MessageModal.alert("請輸入驗證碼");
    } else {

      callMobileAuth(VerifyCode).then(payload => {
        const isPayloadValid =
          payload?.status !== undefined &&
          payload?.errorCode !== undefined &&
          payload?.data !== undefined &&
          payload?.errorMessage !== undefined;

        if (isPayloadValid) {
          if (payload.status === 0 && payload.errorCode === '0000') {
            //處理結果
            if (Cookies.get('cookieConsent') === 'accepted') {
              Cookies.remove('offsetSecond');
            }
            if (isGoToMemberProfile) {
              navigate('/MemberProfile');
            } else {
              navigate('/PlateSetting');
            }
          } else if (payload.status === 1 &&
            (payload.errorCode === '9997' || payload.errorCode === '9998')) {
            //未登入
            let errorMessage = "Token過期，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else if (payload.status === 1 && payload.errorCode === '9996') {
            //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
            let errorMessage = "查無此會員，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else {
            const handleError = () => {
              setVerifyCode('');
              if (inputVerifyCodeRef.current) {
                inputVerifyCodeRef.current.focus();
              }
            };

            let errorMessage = payload.errorMessage;
            MessageModal.alert(errorMessage, handleError);
          }
        }
      }).catch(error => {
        console.error('Error during API call:', error);
      });

    }

    event.target.reset();
  };

  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />

      {/* Page Title */}
      <PageTitle title={'手機驗證'} page={'phone-verifyy'} />

      <section className='phoneVerify'>

        {/* Verify Form */}
        <form className='account-form' onSubmit={handleSubmit}>

          {/* User Icon */}
          <div className='icon'><FaMobile /></div>

          {/* Heading for the register form */}
          <h3>請輸入您收到的驗證碼</h3>
          {/* Terms and Conditions Checkbox */}
          <div className='terms'>
            <label >我們已經發送驗證碼到您的手機：{mobileNo}。如果您的手機有錯誤，請重新修正。<Link to="/MemberProfile"><span>修改會員資料</span></Link>。</label>
          </div>
          {/* verifyCode Input */}
          <div className="input-field">
            <label htmlFor="verifyCode"><FaPenFancy /></label>
            <input type="text" name="verifyCode" placeholder="請輸入驗證碼" id="verifyCode" className="box"
              value={VerifyCode} onChange={handleVerifyCode} ref={inputVerifyCodeRef} />
          </div>
          {/* Terms and Conditions Checkbox */}
          <div className='terms'>
            當您收到簡訊時，請輸入收到的驗證碼。如果您沒有收到或是已經超過三分鐘沒有輸入，請重新請求驗證。
          </div>
          {/* Register Button */}
          <button name='submit' id='submit' className='btn'>填寫完成</button>
          <CountdownButton initialTime={countdownTime} onClick={handleCountdownButton} />

        </form>

      </section>
    </>
  );
}

export default PhoneVerify;